import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'

const TAG_INPUT = graphql.transformers.IN.object<
  ents.core.common.Tag,
  graphql.schema.TagInput
>({
  key: graphql.transformers.IN.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
  ),
  value: transformers.PASS_THROUGH,
})

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.User.Input,
    graphql.schema.UserInput
  >({
    email: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
    ),
    employeeId: transformers.PASS_THROUGH,
    firstName: transformers.PASS_THROUGH,
    isPlatformAdmin: transformers.PASS_THROUGH,
    isTenant: graphql.transformers.IN.default(transformers.PASS_THROUGH, false),
    jobTitle: transformers.PASS_THROUGH,
    lastName: transformers.PASS_THROUGH,
    phoneNumber: transformers.PASS_THROUGH,
    tags: graphql.transformers.IN.list(TAG_INPUT, {
      onNullish: 'remove',
    }),
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.User.Updates,
    graphql.schema.UserUpdates
  >({
    email: transformers.PASS_THROUGH,
    employeeId: transformers.PASS_THROUGH,
    firstName: transformers.PASS_THROUGH,
    isPlatformAdmin: transformers.PASS_THROUGH,
    jobTitle: transformers.PASS_THROUGH,
    lastName: transformers.PASS_THROUGH,
    phoneNumber: transformers.PASS_THROUGH,
    tags: graphql.transformers.IN.list(TAG_INPUT, {
      onNullish: 'remove',
    }),
  }),
)
